import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import ProductassetEditFormImpl from './ProductassetEditFormImpl';
import ProductassetList from './ProductassetList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import ProductassetListView from './ProductassetListView'


export default function ProductassetDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.productassetDashboard);
  const [ productassetId, setProductassetId] = React.useState('');
  const [reloadProductassetList, setReloadProductassetList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <ProductassetEditFormImpl 
            setReloadProductassetList={setReloadProductassetList}
            productassetId={productassetId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <ProductassetListView 
                      setProductassetId = {setProductassetId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
